import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import PriceList from "./PriceList";

const OwnedTradeInTable = ({ appraisalDetails, t }) => {
  return (
    <>
      <Typography variant="h3" sx={{ color: "text.primary" }}>
        {t("TradeIn.ModelE.appraisalAmount")}
      </Typography>

      <Typography variant="body2">
        {t("OrderDetailsConsumerDeposit.tradeInAppraisalTooltipBody")}
      </Typography>

      <Typography variant="h5" sx={{ mt: 2, mb: 3 }}>
        {appraisalDetails.appraisalVehicle}
      </Typography>

      <PriceList
        amounts={appraisalDetails.amounts}
        netEquity={appraisalDetails.netEquity}
        t={t}
      />
    </>
  );
};

OwnedTradeInTable.propTypes = {
  appraisalDetails: PropTypes.shape({
    appraisalVehicle: PropTypes.string,
    amounts: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      })
    ),
    netEquity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export default OwnedTradeInTable;
